import ForwardRef from "../../../../../icons/dist/react/minimal/chevron.js";
import { jsx } from "react/jsx-runtime";
import { cn } from "@videojs/utils/style";
//#region src/internal/skins/minimal-video/components/menus/menu-chevron.tsx
/** @jsxImportSource react */
function MenuChevron({ back = false, className } = {}) {
	return /* @__PURE__ */ jsx(ForwardRef, { className: cn(back ? "media-menu-back-chevron" : "media-menu-forward-chevron", className) });
}
//#endregion
export { MenuChevron };

//# sourceMappingURL=menu-chevron.js.map